import React from 'react'
import { browserHistory } from 'react-router'
import DocumentTitle from 'react-document-title'
import { ProfileForm, DeleteUserWidget } from '../components'
import authentication from '../http/auth'


export default class ProfilePage extends React.Component {

  deleteUser() {
    let username = localStorage.getItem('username')
    authentication.delete(username, (result) => {
      if (result) {
        browserHistory.push('/login')
      } else {
        browserHistory.push('/')
      }
    })
  }

  updateUser(password, confirm, id, key, cb) {
    let username = localStorage.getItem('username')
    authentication.update(username, password, confirm, id, key, cb)
  }

  render() {
    return (
      <DocumentTitle title={'Café App'}>
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h3>Editer votre profil</h3>
              <hr />
            </div>
          </div>
          <ProfileForm updateUser={ this.updateUser.bind(this) } />
          <div className="row">
            <div className="col-xs-12">
              <h3>Supprimer votre profil</h3>
              <hr />
            </div>
          </div>
          <DeleteUserWidget deleteUser={ this.deleteUser.bind(this) } />
        </div>
      </DocumentTitle>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProfilePage.js